// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8120":"e872979c","9966":"3dea72fa"}[chunkId] + ".chunk.css";
};